import React from 'react';
import { contact } from '../data/products';
import { translations } from '../data/translations';
import { useLanguage } from '../context/LanguageContext';

function Producer() {
  const { t } = useLanguage();

  return (
    <section id="producer" className="producer">
      <div className="container">
        <div className="producer-content">
          <div className="producer-text">
            <h2 className="producer-title">{t(translations.producer.title)}</h2>
            <p className="producer-description">{t(translations.producer.text)}</p>
            <div className="producer-cta">
              <a href={`tel:${contact.phone}`} className="btn btn-primary btn-large">
                <span className="btn-icon">{'\u{1F4DE}'}</span>
                {t(translations.producer.visitUs)}
              </a>
            </div>
          </div>
          <div className="producer-info">
            <div className="producer-card">
              <div className="producer-card-icon">{'\u{1F3E2}'}</div>
              <h3>Perfectwin Showroom</h3>
              <p className="producer-address">
                <span className="address-icon">{'\u{1F4CD}'}</span>
                {t(translations.producer.address)}
              </p>
              <p className="producer-phone">
                <span className="phone-icon">{'\u{1F4DE}'}</span>
                <a href={`tel:${contact.phone}`}>{contact.phone}</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Producer;
